import {register} from '../../../assets/js/modules/eventMap';

const init = (el) => {
    const form = el.form;

    if (!form) {
        return;
    }

    const messages = form.querySelectorAll(
        '[data-kinde-control-pattern-message]'
    );

    if (messages.length) {
        messages.forEach((input) => {
            const message = input.dataset.kindeControlPatternMessage;

            if (input.validity.patternMismatch) {
                input.setCustomValidity(message);
            } else {
                input.setCustomValidity('');
            }
        });
    }
};

const showControlPatternMessage = () => {
    register('showControlPatternMessage', {init});
};

export {showControlPatternMessage};
